import { useMaybePolicy } from '../application/product/policy/PolicyProvider'
import { useMaybeProposal } from '../application/product/proposal/ProposalProvider'
import { getContentBaseUrl, useConfig } from '../state/configuration'

export const useHelpLink = (name: string | undefined) => {
  const baseUrl = useConfig(getContentBaseUrl)
  const proposal = useMaybeProposal()
  const policy = useMaybePolicy()

  const { schemeCode } = proposal ?? policy ?? {}

  return name
    ? [baseUrl, schemeCode, 'questions', `${name}.html`].filter(Boolean).join('/')
    : undefined
}
